module.exports = __webpack_public_path__ + "static/media/integrity.0cf785c4.png";